export default __webpack_public_path__ + "static/media/higher_primary_hi_ident_url_tagline_uppercase_reversed.adafa18e.svg";